import { makeStyles } from 'tss-react/mui';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useSettingsStyles = makeStyles()((theme) => ({
  root: {
    fontSize: '18px',
    padding: theme.spacing(0.5)

  },
  fontWeight500: {
    fontWeight: 500
  },
  phoneTable: {
    width: 'fit-content',
    '& td': {
      padding: 0,
      borderBottom: 'none',
    },
    '& td:not(:last-of-type)': {
      paddingRight: theme.spacing(2)
    },
    '& tr:not(:last-of-type) td': {
      paddingBottom: theme.spacing(0.5)
    }
  },
  formGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    maxWidth: '400px'
  },
  buttonRow: {
    padding: theme.spacing(2)
  },
  link: {
    color: theme.palette.text.primary,
    fontFamily: 'inherit',
    verticalAlign: 'baseline'
  },
  maxWidth120: {
    maxWidth: '120px'
  },
  disabledTextInput: {
    background: theme.palette.grey[200],
    color: theme.palette.text.primary
  },
  insuranceHeader: {
    background: theme.palette.grey[50],
    zIndex: 1,
    paddingTop: theme.spacing(1),
    marginTop: theme.spacing(-1),
  },
  adminInsuranceHeader: {
    paddingBottom: theme.spacing(1),
  },
  archivedInsuranceHeader: {
    paddingBottom: theme.spacing(2),
  },
  semiBold: {
    fontWeight: 500
  },
  spacing: {
    paddingLeft: theme.spacing(1)
  },
  toggle: {
    width: theme.spacing(9),
    color: theme.palette.text.primary
  },
  editIcon: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(1)
  },
  gridPadding: {
    paddingBottom: theme.spacing(2),
  },
  cardToggle: {
    width: theme.spacing(15),
    color: theme.palette.text.primary
  },
  needsReview: {
    fontSize: '16px'
  },
  verified: {
    color: theme.palette.text.primary
  },
  customHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  archivedBy: {
    display: 'flex',
    alignItems: 'center',
    height: '100%'
  },
  reason: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
    height: '100%'
  }
}));
